import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PlayList from './PlayList';
import $ from 'jquery';
import _ from 'underscore';

import VideoScreen from './VideoScreen';

import modelObj from './CookieUtils';

import { faPause } from '@fortawesome/free-solid-svg-icons';
import { BsArrowsFullscreen } from 'react-icons/bs';
import { isMobile } from 'react-device-detect';

import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import PulseLoader from 'react-spinners/PulseLoader'
import { useTranslation } from 'react-i18next';


export default function VideoList(props) {

	var useLang = localStorage.getItem("language");

    var playList = null;

	var isEndList = false;
	var listSize = 50;

	let dataNum = null;

	// const [dataNum, setDataNum] = useState();

	const [dataKey, setDataKey] = useState();

	const [path, setPath] = useState(" ");

	const [frontTime, setFrontTime] = useState(2);

	const [duration, setDuration] = useState(7);

	const [page, setPage] = useState(0);

	const [loading, setLoading] = useState(null);

	const [listLoading, setListLoading] = useState(false);

	const [anotherPath, setAnotherPath] = useState();

	const [playing, setPlaying] = useState(null);

	const [icon, setIcon] = useState(faPause);

	const [captionState, setCaptionState] = useState(true);

	const { t } = useTranslation();

	//setPath 설정 여부를 결정하기 위해 사용할 gameID
	var gameID = null;

	const [criteria, setCriteria] = useState({
		seasons: [],
		month: "",
		gameType: "4201",
		position: "batter",
		teamId: 2001,
		oppTeamId: 0,
		batterIds: [],
		pitcherIds: [],
		playerIds: [],
		oppPlayerIds: [],
		latestGames: false,
		checkbase: false,
		gameInfoIds: [],
		innings: [],
		ballCodes: [],
		runnerStatus: [],
		ballCounts: [],
		hitTypes: [],
		hitResults: [],
		checkbases: [],
		battedBallRank: [],
		videoType:"broadCast",
		beginIdx:0,
		listSize:50
	});

	const [hitCriteria, setHitCriteria] = useState({
		gameInfoIds:[],
		gameRecordIds:[]
	});

	// const [newCriteria, setNewCriteria] = useState([{
	// 	serviceName:"gameRecordService",
	// 	subServiceName:"pbpWithPitchTime",
	// 	sortColumn:"",
	// 	returnName:"pbpWithPitchTime",
	// 	parameterSet:props.parameterSet,
	// 	teamId:"0",
	// 	inning:"",
	// 	gameTypeCode:"4201",
	// }]);
	
	const [videoList, setVideoList] = useState({
		playList:[],
        useLang:null,
		cookie:modelObj
	});

	useEffect(() => {
		var newObj = {};
		if(props.content == "hitCourse"){
			newObj = {...hitCriteria, ...props.parameterSet}
			setHitCriteria(newObj);
		} else {
			newObj = {...criteria, ...props.parameterSet}
			setCriteria(newObj);
		}
	},[]);

    useEffect(() => {
		if (criteria.playerIds.length !== 0){

			setLoading(true);

			if(props.content == "recentGame"){
				axios({
					method: "post",
					url: `${process.env.REACT_APP_VIDEO_URL}/tmp/game/videoClips`,
					headers:{
						"Content-Type": 'application/json',
					},
					data: criteria,
					responseType: "json",
					withCredentials: true,
				})
					.then((response) => {
						successHandler(response);
					})
					.catch(function (error) {
						
					});

			} else if(props.content == "playerSlide") {
				axios({
					method: "post",
					url: `${process.env.REACT_APP_VIDEO_URL}/tmp/game/videoClipByPlayer`,
					headers:{
						"Content-Type": 'application/json',
					},
					data: criteria,
					responseType: "json",
					withCredentials: true,
				})
					.then((response) => {
						successHandler(response);
					})
					.catch(function (error) {
						
					});
				
			}
		} 
    },[criteria.playerIds]);

	useEffect(() => {
		if(criteria.beginIdx > 0){
			if(listLoading == true){
				//로딩 O
				
				if(props.content == "recentGame") {
					axios({
						method: "post",
						url: `${process.env.REACT_APP_VIDEO_URL}/tmp/game/videoClips`,
						headers:{
							"Content-Type": 'application/json',
						},
						data: criteria,
						responseType: "json",
						withCredentials: true,
					})
						.then((response) => {
							appendListHandler(response);
						})
						.catch(function (error) {
						});

				} else if(props.content == "playerSlide"){
					axios({
						method: "post",
						url: `${process.env.REACT_APP_VIDEO_URL}/tmp/game/videoClipByPlayer`,
						headers:{
							"Content-Type": 'application/json',
						},
						data: criteria,
						responseType: "json",
						withCredentials: true,
					})
						.then((response) => {
							appendListHandler(response);
						})
						.catch(function (error) {
						});
				}
			} 
		}
	},[criteria.beginIdx]);

	useEffect(() => {
		//타구분포차트 api 호출
		if (hitCriteria.gameRecordIds.length !== 0){
			setLoading(true);

            axios({
                method: "post",
                url: `${process.env.REACT_APP_VIDEO_URL}/tmp/game/videoClipById`,
				headers:{
					"Content-Type": 'application/json',
				},
                data: hitCriteria,
                responseType: "json",
                withCredentials: true,
            })
                .then((response) => {
                    successHandler(response);
                })
                .catch(function (error) {
				});
		} 
	},[hitCriteria]);

	useEffect(() => {
		if(typeof dataKey !== 'undefined' && dataKey !== null){
			highlightListHandler();
		}
	},[dataKey]);

	useEffect(() => {
		//path가 바뀔때 스피너를 넣어주는 방법 이용
		if(loading == false){
			setLoading(true);
		}
	},[path]);

	useEffect(() => {
		settingCaptionOnOff();
	},[captionState]);

    const successHandler = (response) => {
		setLoading(false);
		
        var result = response.data;
        var gameVideoRecord = result.resultList;
        var records = 0; 
        records = _.size(gameVideoRecord);

        if (records !== 0) {
			if(props.content == "recentGame" || props.content == "playerSlide"){
				//리스트의 개수가 적다면 스크롤 핸들러 X				
				if(records > 49) {
					$("#clipListWrap").on("scroll", listScrollHandler);
				}
			}

			playList = gameVideoRecord;
			//Axios 통신 결과를 playList에 저장 
			setVideoList((prevState) => ({
				...prevState,
				playList:playList
			}));

			playFirstClipHandler(playList);

			adjustListSizeHandler();

        } else {
			if(props.useLang === "en"){
				alert("Please check the video tagging information");
			} else {
				alert("영상 태깅 정보를 확인 하여 주십시오!");
			}
        }

		//영상 재생 방법 클릭 이벤트 핸들러 (repeat, sequence, justplay)
		$("[name='playingType']").on('click', selectPlayingTypeHandler);

		var playerScreen = document.getElementById("playerScreen");
		var video = playerScreen.getElementsByTagName('video');
		video[0].addEventListener("webkitendfullscreen", (evt) => {
			//모바일에서 화면을 닫아 영상이 멈췄을때 할 동작을 설정
			setPlaying(false);
			setIcon(faPause);
			$("#screenController").animate({opacity:0.5}, 300);
			$('#playIcon').animate({opacity:0.8}, 300);
		});

		document.addEventListener("fullscreenchange", (evt) => {
            if(document.fullscreenElement == null){
                //전체화면이 아닐 경우
                $("#videoTextDiv").css("height","30px");
                $("#videoTextArea").css("font-size","15px");
                $("#videoTextArea").css("padding","4px 0px");
            } else {
                //전체화면일 경우
                $("#videoTextDiv").css("height","60px");
                $("#videoTextArea").css("font-size","30px");
                $("#videoTextArea").css("padding","8px 0px");
            }
        });
    }


	//영상 목록 높이 조절 이벤트 핸들러
	const adjustListSizeHandler = () => {
		var screenHeight = document.getElementById("playerScreen").clientHeight;
		var filterHeight = document.getElementById("listFilter").clientHeight;
		var titleHeight = document.getElementById("videoClipTitle").clientHeight;
		var listHeight = screenHeight-filterHeight-titleHeight;
		$("#videoClipList").height(listHeight);
	}

	const playFirstClipHandler = (list) => {

		var findPitch = list[0];
		var rel = findPitch.gameInfoId + findPitch.gameRecordId + findPitch.inning + findPitch.inningTb + findPitch.batInningTurn + findPitch.batPitchSeq;

		dataNum = rel;
		setDataKey(rel);

		var selectedVideoPath = findPitch.videoPath;
		var selectedGoogleVideoPath = findPitch.googleVideoPath;
		var startTime = findPitch.pitchTime - findPitch.taggingGapTime;
		var mp4VideoPath = selectedVideoPath.replace("/mp4hls/index.m3u8"," ");

		setPath(selectedGoogleVideoPath);
		setAnotherPath(mp4VideoPath);

		settingClipPlay(startTime, findPitch);

	}


	//영상 목록에서 경기 선택 이벤트 핸들러
	const selectClipEventHandler = (evt) => {
		var target = $(evt.currentTarget);
		var selectedPitch = target.attr("rel");
		var playingType = getPlayingType();

		if(playingType == 'justplay'){
			setCaptionState(true);
		}

		if(dataNum != selectedPitch){
			//만약 선택한 영상이 재생중인 영상과 다르면
			//$("[name='videoClips']").css("backgroundColor","");

			dataNum = selectedPitch;
			setDataKey(selectedPitch);

			//영상이 일시정지 된 상태로 다른 영상을 클릭했을 때 화면 어두운 효과 제거
			$('#playIcon').animate({opacity:0}, 300);
			$('#screenController').animate({opacity:0}, 300);

			//playList에서 내가 선택한 경기의 rel 값과 동일한것 찾기
			var findPitch = videoList.playList.find(function(pitch){
				var currentKey = pitch.gameInfoId+''+pitch.inning+''+pitch.inningTb+''+pitch.batInningTurn+''+pitch.batPitchSeq;
				return currentKey === selectedPitch;
			});
		
			//리턴받은 findPitch에서 path(src) 값 추출
			var selectedVideoPath = findPitch.videoPath;
			var selectedGoogleVideoPath = findPitch.googleVideoPath;
			var startTime = findPitch.pitchTime - findPitch.taggingGapTime;

			var g_ID = findPitch.gameInfoId;

			var mp4VideoPath = selectedVideoPath.replace("/mp4hls/index.m3u8"," ");

			//스크롤이 넘어가면 화면이 다시 그려지면서 setPath를 해주는 상황
			if(gameID != g_ID){
				gameID = g_ID;
				
				//VideoScreen으로 넘겨줄 src 값을 set 해준다.
				setPath(selectedGoogleVideoPath);
				setAnotherPath(mp4VideoPath);

			}

			settingClipPlay(startTime, findPitch);

		} else {
			//선택한 영상이 재생중인 영상과 같으면
		}

		
	}

	const settingClipPlay = (startTime, pitchInfo) => {
		//영상의 시작시간(frontTime)과 재생시간(duration) 설정
		var checkBase = pitchInfo.checkBase;
		var hitResultCode = pitchInfo.hitResultCode;
		var beforeOutCount = pitchInfo.beforeOutCount;
		var beforeRunnerState = pitchInfo.beforeRunnerState;
		var outCount = pitchInfo.outCount;
		
		//switch도 동일한 방법으로 값을 가져올 수 있음
		var forStaff = $("#forStaff").is(":checked");
		
		// Default frontTime = 2 & duration = 7
		var f_Time = 2;
		//var d_Time = 7;
		setDuration(7);
		
		if (typeof(checkBase) != 'undefined' && (checkBase != '0' || checkBase != 0 )) {
			//견제
			f_Time = 5;
			//d_Time = 10;
			setDuration(10);
		}
		
		if (typeof (hitResultCode) != 'undefined' && (hitResultCode != '0' || hitResultCode != 0)) {
			// 타격 결과가 있는 경우 frontTime = 2 & duration = 10
			f_Time = 2;
			//d_Time = 10;
			setDuration(10);
			if (beforeOutCount != outCount) {
				//타격 결과가 있고 아웃카운트에 변동이 있을 경우 frontTime = 2 & duration = 17
				//d_Time = 17;
				setDuration(17);
			}
		}

		if(forStaff && (beforeRunnerState != 0 || beforeRunnerState!= '0')) {
			// 코치용 재생시간 설정
			f_Time = 7;
			//d_Time = 17;
			setDuration(17);
		}

		var currentPlayingTime = startTime - f_Time;
		setFrontTime(currentPlayingTime);

		//자막 출력 여부 결정
		settingCaptionOnOff();

		//자막 텍스트 생성
		var videoText = trackTextMake(pitchInfo);
		$("#videoTextArea").html(videoText);
	}
	
	const trackTextMake = (info) => {
        //자막 생성하는 함수
        var checkBase = info.checkBase;
        var gameDay = getGameDay(info);
        var inning = info.inning;
        var inningTb = getInningTb(info);
        var batterName = getBatterName(info);
        var pitcherName = getPitcherName(info);
        var beforeStrikeCount = info.beforeStrikeCount;
        var beforeOutCount = info.beforeOutCount;
        var beforeBallCount = info.beforeBallCount;
        var ballCodeName = getBallCodeName(info);
        var ballSpeed = info.ballSpeed == null ? "0" : info.ballSpeed;
        var hitResultName = getHitResult(info);
        var beforeRunnerState = getRunnerState(info);
        var checkBaseState = getCheckBaseState(info);
        var result = "";
        if (checkBase < 1) {
            result =
                "[" +
                gameDay +
                "]  " +
                inning +
                inningTb +
                " " +
                batterName +
                " vs " +
                pitcherName +
                " " +
                beforeBallCount +
                "B-" +
                beforeStrikeCount +
                "S" +
                " " +
                beforeOutCount +
                "OUT" +
                " " +
                ballCodeName +
                ", " +
                ballSpeed +
                "km" +
                " " +
                hitResultName +
                ", " +
                beforeRunnerState;
        } else {
            result =
                "[" +
                gameDay +
                "]  " +
                +inning +
                inningTb +
                " " +
                batterName +
                " vs " +
                pitcherName +
                " " +
                beforeBallCount +
                "B-" +
                beforeStrikeCount +
                "S" +
                " " +
                beforeRunnerState +
                ", " +
                checkBaseState;
        }

        return result;
    };

	const getGameDay = (item) => {
        var gameDay = item.gameDay;
        var arr = gameDay.split('-');
        var gameDayFormat = arr[0].substr(-2) + "/" + arr[1] + "/" + arr[2];
        return gameDayFormat;
    }

    const getInningTb = (item) => {
        if (item.inningTb == "0") {
            return t('top');
        } else {
            return t('bottom');
        }
    };

    const getBatterName = (item) => {
        if (useLang == "en") {
            //영어일 경우
            if (item.batterForeignerYn == "Y") {
                return item.batterLastName;
            } else {
                return item.batterLastName + " " + item.batterShortName;
            }
        } else {
            //한국어일 경우
            return item.batterName;
        }
    };

    const getPitcherName = (item) => {
        if (useLang == "en") {
            //영어일 경우
            if (item.pitcherForeignerYn == "Y") {
                return item.pitcherLastName;
            } else {
                return (
                    item.pitcherLastName + " " + item.pitcherShortName
                );
            }
        } else {
            //한국어일 경우
            return item.pitcherName;
        }
    };

    const getBallCodeName = (item) => {
        if (useLang == "en") {
            return item.ballTypeShortName;
        } else {
            return item.ballCodeName;
        }
    };

    const getHitResult = (item) => {
        if (useLang == "en") {
            return item.hitResultShortName;
        } else {
            return item.hitResultName;
        }
    };

    const getRunnerState = (item) => {
        if (item.beforeRunnerState == 0) {
			return t('nobase');
		} else if (item.beforeRunnerState == 1) {
			return t('1b');
		} else if (item.beforeRunnerState == 2) {
			return t('2b');
		} else if (item.beforeRunnerState == 3) {
			return t('1b2b');
		} else if (item.beforeRunnerState == 4) {
			return t('3b');
		} else if (item.beforeRunnerState == 5) {
			return t('1b3b');
		} else if (item.beforeRunnerState == 6) {
			return t('2b3b');
		} else {
			return t('fullbase');
		}
    };

    const getCheckBaseState = (item) => {
        if (item.checkBase == "1") {
            return t('pick1st');
        } else if (item.checkBase == "2") {
            return t('pick2nd');
        } else if (item.checkBase == "3") {
            return t('pick3rd');
        } else if (item.checkBase == "23") {
            return t('catcherPick1st');
        } else if (item.checkBase == "24") {
            return t('catcherPick2nd');
        } else if (item.checkBase == "25") {
            return t('catcherPick3rd');
        }
    };

	const highlightListHandler = () => {
		var nextKey = dataKey;
		var height = 0;
		var list = $("[name='videoClips']");
		list.removeClass("active");
		
		for (var i=0; i<list.length; i++) {
			var elem = list[i];
			var key = $(elem).attr('rel');
			
			if (key == nextKey) {
				$(elem).addClass('active');
				//$(elem).css("backgroundColor","lightgray");
				$("#clipListWrap").animate({scrollTop:height}, 400);
				break;
			}

			//height += $(elem)[0].clientHeight;
			height += $(elem)[0].getBoundingClientRect().height;
		}
	}

	const settingCaptionOnOff = () => {
        var caption = $("#caption").is(":checked");
        var playingType = getPlayingType();

        if(caption == true){
            //자막 on
            if(playingType == 'justplay'){
                if(captionState == true){
                    $("#videoTextArea").animate({ opacity: 1 }, 10);
					$("#videoTextDiv").animate({ opacity: 1 }, 10);
                } else if (captionState == false) {
                    $("#videoTextArea").animate({ opacity: 0 }, 10);
					$("#videoTextDiv").animate({ opacity: 0 }, 10);
                }
            } else {
                $("#videoTextArea").animate({ opacity: 1 }, 10);
				$("#videoTextDiv").animate({ opacity: 1 }, 10);
            }
        } else {
            //자막 off
            $("#videoTextArea").animate({ opacity: 0 }, 10);
			$("#videoTextDiv").animate({ opacity: 0 }, 10);
        }
    }

	const getPlayingType = () => {
		var playingType = '';
		var types = $("[name='playingType']");
		_.each(types, function (type){
			if ($(type).hasClass('active')) {
				playingType = $(type).val();
			}
		});
		
		return playingType;

	}

	const selectPlayingTypeHandler = (evt) => {
		//영상 재생 방법 클릭 이벤트 핸들러
		$("[name='playingType']").removeClass("active");
		$(evt.currentTarget).addClass('active');
		// var playingType = $(evt.currentTarget).val();

	}

	const listScrollHandler = (e) => {
		//영상 목록 스크롤 이벤트 핸들러
		var currentScrollTop = $("#clipListWrap").scrollTop(); //스크롤바의 상단위치
        var scrollH = $("#clipListWrap").height(); //스크롤바를 갖는 div의 높이
        var contentH = $("#clipContents").height(); //문서 전체 내용을 갖는 div의 높이
		
        if(!isEndList && currentScrollTop + scrollH + 1 >= contentH) {
			$("#clipListWrap").off("scroll", listScrollHandler);

			setListLoading(true);

            var num = page + 1;
			setPage(num);

			var beginIdx = (num*listSize);

			setCriteria((prevState) => ({
				...prevState,
				beginIdx:beginIdx
			}));
            
        }
	}

	const appendListHandler = (result) => {
		//영상 목록에서 스크롤을 내렸을 때 목록이 추가되도록 해주는 이벤트 핸들러	
		var res = result.data.resultList;
		var retrievedSize = res.length;

		if (retrievedSize < listSize) {
			isEndList = true;
		}
		
		if (videoList.playList != null) {
			playList = videoList.playList.concat(res);
			
			setVideoList((prevState) => ({
				...prevState,
				playList:playList
			}));

			setListLoading(false);

			//클릭 이벤트 제거
			//$("[name='videoClips']").off("click", selectClipEventHandler);
			//영상 목록 클릭 이벤트 핸들러
			//$("[name='videoClips']").on("click", selectClipEventHandler);
			
		} else {
			playList = res;
		}

		$("#clipListWrap").on("scroll", listScrollHandler);

	}
	

	const fullScreenEventHandler = () => {
		//전체화면 버튼 클릭 이벤트
		var playerScreen = document.getElementById("playerScreen");
		var video = playerScreen.getElementsByTagName('video');

		//영상 선택 여부 확인
		if($(video[0]).attr('src') == " "){
			if(props.useLang === "en"){
                alert("Please select a video first");
            } else {
                alert("재생할 영상을 선택해주세요");
            }

		} else {
			if(isMobile) {
				//모바일 화면일 경우
				video[0].webkitEnterFullScreen();
			} else {
				//PC일 경우
				playerScreen.requestFullscreen();
			}
		}
		
	}
	

	return (
		<div className="container-fluid">
			<div id="videoWrapper" className="row video_wrap" style={{margin:"1px", padding:"0px", width:"100%"}}>
				<div className="col-12 col-sm-7 col-md-12 col-lg-8 col-xl-8 screen_wrap" style={{padding:"0px"}}>
					<table className="screen-controller-tb" style={{width:"100%"}}>
						<tbody>
							<tr>
								<td id="playerScreen" className="video_player" style={{verticalAlign:"top", padding:"0px"}}>
									<VideoScreen
										path={path}
										frontTime={frontTime}
										setFrontTime={setFrontTime}
										duration={duration}
										setDuration={setDuration}
										dataKey={dataKey}
										setDataKey={setDataKey}
										playList={videoList.playList}
										setPath={setPath}
										settingClipPlay={settingClipPlay}
										loading={loading}
										setLoading={setLoading}
										anotherPath = {anotherPath}
										setAnotherPath = {setAnotherPath}
										useLang={props.useLang}
										playing={playing}
										setPlaying={setPlaying}
										icon={icon}
										setIcon={setIcon}
										trackTextMake={trackTextMake}
										getPlayingType={getPlayingType}
										setCaptionState={setCaptionState}
									/>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div className="col-12 col-sm-5 col-md-12 col-lg-4 col-xl-4 list_wrap" style={{padding:"0px"}}>
					<table style={{marginLeft:"5px"}}>
						<tbody>
							<tr>
								<td id="listFilter" className="list-controller">
									<table style={{width:"100%"}}>
										<tbody>
											<tr>
												<td>
													<table style={{width:"100%"}}>
														<tbody>
															<tr>
																<td style={{float:"left", padding:"2px"}}>
																	<div id='switchArea' style={{display:"inline-block", marginTop:"6px", fontSize:"90%"}}>
																		<Form.Check type="switch" id="forStaff" label={t('forStaff')} style={{float:"left"}} />
																		<Form.Check type="switch" id="caption" label={t('caption')} style={{float:"left", marginLeft:"10px"}} defaultChecked={true} onChange={settingCaptionOnOff} />
																	</div>
																</td>
															
																<td style={{float:"right"}}>
																	{/* <h6 style={{float:"left",marginTop:"9px"}}><small style={{fontSize:"17px"}} data-lang="watchType">재생방법</small></h6> */}
																	<div id='playingTypeBtnArea' className="btn-group" style={{float:"left", marginLeft:"10px", height:"40px"}}>
																		<Button variant="outline-secondary" name="playingType" value="repeat" type="button" className="btn-default active" style={{fontSize:"10px"}}>
																			{/* <BsArrowRepeat style={{fontSize:"18px"}}></BsArrowRepeat> */}
																			<span className='repeat-img'></span><br/>{t('repeat')}
																		</Button>
																		<Button variant="outline-secondary" name="playingType" value="sequence" type="button" className="btn-default" style={{fontSize:"10px"}}>
																			{/* <BiLoaderCircle style={{fontSize:"18px"}}></BiLoaderCircle> */}
																			<span className='sequence-img'></span><br/>{t('sequence')}
																		</Button>
																		<Button variant="outline-secondary" name="playingType" value="justplay" type="button" className="btn-default" style={{fontSize:"10px"}}>
																			{/* <RiLoader4Fill style={{fontSize:"18px"}}></RiLoader4Fill> */}
																			<span className='justplay-img'></span><br/>{t('justplay')}
																		</Button>
																	</div>
																</td>

																<td style={{float:"right"}}>
																	<Button id='fullScreenBtn' variant='outline-secondary' value="fullScreen" type="button" onClick={fullScreenEventHandler} style={{height:"40px"}}>
																		{/* {props.useLang === 'en' ? "Full Screen" : "전체화면"} */}
																		<BsArrowsFullscreen></BsArrowsFullscreen>
																	</Button>
																</td>
															</tr>
														</tbody>
													</table>
												</td>
											</tr>
										</tbody>
									</table>
								</td>
							</tr>
							<tr>
								<td id="clipList">
									<div style={{position:"relative", display:"flex", justifyContent:"center", alignItems:"center"}}>
										<Table className="player-list" style={{tableLayout:"fixed",width:"100%"}}>
											<tbody>
												<tr>
													<td id='videoClipTitle' style={{height:"auto", padding:"0px"}}>
														<div style={{overflowY:"scroll", height:"100%", width:"100%", border:"0px solid #e3e3e3"}}>
															<table id="videoTitleTable" style={{width:"100%", height:"100%", textAlign:"center", overflow:"hidden", whiteSpace:"nowrap"}}>
																<tbody>
																	<tr>
																		<th className="title" width="15%" data-lang="pitch">{t('pitch')}</th>
																		<th className="title" width="15%">B-S</th>
																		<th className="title" width="20%" data-lang="pitchType">{t('pitchType')}</th>
																		<th className="title" width="20%" data-lang="pitchSpeed">{t('speed')}</th>
																		<th className="title" width="15%" data-lang="result">{t('result')}</th>
																		<th className="title" width="15%" data-lang="pickOffs">{t('pickoffs')}</th>
																	</tr>
																</tbody>
															</table>
														</div>
													</td>
												</tr>
												<tr>
													<td id="videoClipList" style={{padding:"0px"}}>
														<div id="clipListWrap" style={{overflowY:"scroll", height:"100%", width:"100%"}}>
															<div id="clipContents" style={{overflow:"hidden", whiteSpace:"nowrap"}}>
																<PlayList criteria={criteria} content={props.content} playList={videoList.playList} cookie={videoList.cookie} useLang={useLang} selectClipEventHandler={selectClipEventHandler} />
															</div>
														</div>
													</td>
												</tr>
											</tbody>
										</Table>
										<div style={{position:"absolute", zIndex:"10"}}>
											{listLoading ? <PulseLoader color="#000000" height={15} width={5} radius={2} margin={2}/> : null}                
										</div>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

	);
    
}
